import { useTranslation } from "next-i18next";
import Icon from "@ui-kit/icons/Icon.web";
import { Badge, ChildBadgeProps } from "@ui-kit/data-display/Badge/Badge";

export const PaymentPlansBadge = ({ isVisible = true }: ChildBadgeProps) => {
  const { t } = useTranslation("purchases");

  const icon = (
    <Icon.DollarFilled
      boxSize={{ base: "element.md", sm: "element.xl" }}
      mr="sm"
      aria-label={t("dollar icon")}
    />
  );

  return (
    <Badge
      icon={icon}
      text={t("Payment Plans Available")}
      isVisible={isVisible}
      data-testid="payment-plans-badge"
    />
  );
};
